/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha Dhanireddy <snigdha.dhanireddy@mroads.com>, Jun 2023
 * @flow
 */


import React, { useState } from 'react';
import cn from 'classnames';
import Card from '@material-ui/core/Card';
import { Box, Grid, Typography } from '@material-ui/core';
import useStyles from './useStyles';
import { useSelector } from 'react-redux';

const ServerLookup = ({ onEmployeeSelection, employees }) => {
  const classes = useStyles();
  const { labelsData } = useSelector(state => state);
  const { labels: strings } = labelsData;
  const [servers, setServers] = useState(employees);

  const onSelection = (employee) => {
    const updatedServers = servers.map(each => {
      if (each.id === employee.id) {
        return {
          ...each,
          isSelected: true,
        }
      } else {
        return {
          ...each,
          isSelected: false,
        }
      }
    });
    setServers(updatedServers);
    onEmployeeSelection(employee);
  }

  return (
    <Box>
      <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} mb={1} mt={3} pl={0.5} pr={0.5}>
        <Typography variant='body1' className={classes.label}>{strings.ASSIGN_SERVER}</Typography>
        <Typography variant='body2' className={classes.optional}>{strings.ASSIGN_OPTIONAL}*</Typography>
      </Box>
      <Box maxHeight={200} overflow={'scroll'} mb={3}>
        <Grid container>
          {servers.map(employee => {
            return (
              <ServerCard
                key={`id-${employee.id}`}
                employee={employee}
                onClick={() => onSelection(employee)}
              />
            )
          })}
        </Grid>
      </Box>
    </Box>
  );
};

const ServerCard = ({ employee, onClick }) => {
  const classes = useStyles();
  const { posId, firstName, lastName } = employee || {};
  return (
    <Grid item xs={6} sm={6} md={4} xl={4}>
      <Card elevation={0} className={employee.isSelected ? cn(classes.serverCard, classes.selectedBorder) : classes.serverCard} onClick={onClick}>
        <Typography variant='body2' className={classes.serverText}>{posId}</Typography>
        <Typography variant='body2' className={classes.serverText}>{lastName}</Typography>
        <Typography variant='body2' className={classes.serverText}>{firstName}</Typography>
      </Card>
    </Grid>
  );
};


export default ServerLookup;
